import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import * as React from 'react';
import './index.scss'




function PrizesCreateData(
  prizesImg: string,
  prizesName: string,
  name: string,
  avatar: string,
  Status: string,
  Time: string,
) {
  return { prizesImg, prizesName, name, avatar, Status, Time };
}

const PrizesRows = [
  PrizesCreateData(require('../../assets/leaderboard/pp-1.png'), 'Iphone 15', 'A**x', require('../../assets/leaderboard/pp-2.png'), 'Joined for 1', '1s Ago'),
  PrizesCreateData(require('../../assets/leaderboard/pp-3.png'), 'Alien Laptop', 'A**x', require('../../assets/leaderboard/pp-4.png'), 'Won', '1s Ago'),
  PrizesCreateData(require('../../assets/leaderboard/pp-5.png'), 'Tesla Cybert', 'A**x', require('../../assets/leaderboard/pp-6.png'), 'Joined for 1', '1s Ago'),
]





const CompetationTabs = (): JSX.Element => {
  const [value, setValue] = React.useState('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <>




      <Box className='CompetationTab' sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value} >
          <Box>
            <TabList className='title' onChange={handleChange}>
              <Tab label="Participants" value="1" />
              <Tab label="Rules" value="2" />
              <Tab label="Prize Details" value="3" />
              <Tab label="My Prizes" value="4" />
            </TabList>

          </Box>
          <TabPanel value="1">
            <div className="Prizes">
              <div className="labs-list">
                <div className="item active">
                  All Records
                </div>
                <div className="item">
                  Current
                </div>
              </div>
              <div className="tableBox">
                <TableContainer component={Paper}>
                  <Table size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <div className='header-content br-l-50'>Prizes</div>
                        </TableCell>
                        <TableCell>
                          <div className="header-content">
                            User
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="header-content">
                            Status
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="header-content br-r-50">
                            Time
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {PrizesRows.map((row) => (
                        <TableRow
                          key={`Prizes-${row.Status}`}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                              className='text'
                            >
                              <img src={row.prizesImg} alt="" width={24} style={{
                                marginRight: 6
                              }} />
                              {row.prizesName}
                            </Box>
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <img src={row.avatar} alt="" width={24} style={{
                                marginRight: 6
                              }} />
                              {row.name}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <span>{row.Status}</span>
                          </TableCell>
                          <TableCell>{row.Time}</TableCell>

                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </TabPanel>
          <TabPanel value="2">Item Two</TabPanel>
        </TabContext>
      </Box>
    </>
  );
}

export default CompetationTabs;